import { FC } from 'react';
import { cx } from '@emotion/css';
import { useTranslation } from 'next-i18next';

import { DSButton } from '@stihl-design-system/components';

import { ViewerImageType } from '../image-viewer/image-viewer';
import { MainImageButton } from './main-image-button';
import { GalleryImage } from './images-gallery';

interface ButtonProps {
  selectedImage: GalleryImage | ViewerImageType;
  showMainImageButton: boolean;
  onSetMainImage?: (id: string) => void;
  setShowDeleteConfirmation: (show: boolean) => void;
  className?: string;
  deleteBtnDataTestId?: string;
  inModal?: boolean;
}

export const Buttons: FC<ButtonProps> = ({
  selectedImage,
  showMainImageButton,
  onSetMainImage,
  setShowDeleteConfirmation,
  className,
  deleteBtnDataTestId,
  inModal = false,
}) => {
  const { t } = useTranslation('shared');

  return (
    <div className={cx('flex flex-wrap gap-x-4', className)}>
      {showMainImageButton && (
        <MainImageButton selectedImage={selectedImage} onSetMainImage={(id) => onSetMainImage?.(id)} inModal={inModal} />
      )}
      {selectedImage?.isDeletable && (
        <DSButton
          type="button"
          size="small"
          variant="outline"
          className="bg-white hover:bg-gray-100"
          iconName="bin"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            setShowDeleteConfirmation(true);
          }}
          aria-haspopup="dialog"
          aria-label={`${t('shared_imageUpload_button_delete')} (${selectedImage?.originalFilename})`}
          data-testid={deleteBtnDataTestId ?? 'delete-image-button'}
        >
          {t('shared_imageUpload_button_delete')}
        </DSButton>
      )}
    </div>
  );
};
